<template>
    <div id="app" @contextmenu.prevent >
        <canvas id="the-canvas"></canvas>
        <div class="pagination bottom_line">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="handleChangePage"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>
        <remote-js src="//mozilla.github.io/pdf.js/es5/build/pdf.js"/>
    </div>
</template>

<script>
    import {imageUrl} from '../api/api';
   /* var PDFJS = require('pdfjs-dist');*/
    //import PDFJS from 'pdfjs-dist/build/pdf.js';
    //PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.js');

    export default {
        name: "attachmentView",
        data() {
            return {
                path: "",
                count:0,
                totalPage:0,
                currentPage:0,
                pdf:"",
                pager:{
                    page:1,
                    size:1,
                    total:0
                },
            }
        },
        created: function () {
            window.addEventListener('keydown', this.handleKeyEvent);
        },
        methods: {
            handleKeyEvent(val){
                val.preventDefault();
            },
            handleChangePage(pageNumber){
                this.pdf.getPage(pageNumber).then(function(page) {
                    console.log('Page loaded');
                    var scale = 1.5;
                    var viewport = page.getViewport({scale: scale});
                    // Prepare canvas using PDF page dimensions
                    var canvas = document.getElementById('the-canvas');
                    var context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    // Render PDF page into canvas context
                    var renderContext = {
                        canvasContext: context,
                        viewport: viewport
                    };
                    var renderTask = page.render(renderContext);
                    renderTask.promise.then(function () {
                        console.log('Page rendered');
                    });
                });
            },
            getParams() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if(this.count>3){
                    let vm = this;
                    loading.close();
                    this.path = imageUrl(this.$route.query.path);
                    var pdfjsLib = window['pdfjs-dist/build/pdf'];
                    // The workerSrc property shall be specified.
                    pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/es5/build/pdf.worker.js';
                    var loadingTask = pdfjsLib.getDocument(this.path);
                    loadingTask.promise.then(function(pdf) {
                        vm.pdf = pdf;
                        vm.pager.total = pdf.numPages;
                        console.log('PDF loaded');
                        // Fetch the first page
                        pdf.getPage(1).then(function(page) {
                            console.log('Page loaded');
                            var scale = 1.5;
                            var viewport = page.getViewport({scale: scale});
                            // Prepare canvas using PDF page dimensions
                            var canvas = document.getElementById('the-canvas');
                            var context = canvas.getContext('2d');
                            canvas.height = viewport.height;
                            canvas.width = viewport.width;
                            // Render PDF page into canvas context
                            var renderContext = {
                                canvasContext: context,
                                viewport: viewport
                            };
                            var renderTask = page.render(renderContext);
                            renderTask.promise.then(function () {
                                console.log('Page rendered');
                            });
                        });
                    }, function (reason) {
                        // PDF loading error
                        console.error(reason);
                    });
                    /*let query = this.$router.history.current.query;
                    let path = this.$router.history.current.path;
                    //对象的拷贝
                    let newQuery = JSON.parse(JSON.stringify(query));
                    newQuery.path = 'pdfPreView'
                    newQuery.pid = 1;
                    this.$router.push({ path, query: newQuery });*/
                    this.count=0;
                    return;
                }
                if (this.count < 4) {
                    this.count++;
                    setTimeout(this.getParams, 1000);
                }

            },

        },
            mounted() {
                this.getParams();

            },
            watch: {
                '$route': 'getParams',
            },
        components:{
            'remote-css': {
                render(createElement) {
                    return createElement('link', { attrs: { rel: 'stylesheet', href: this.href }});
                },
                props: {
                    href: { type: String, required: true },
                },
            },
            'remote-js': {
                render(createElement) {
                    return createElement('script', { attrs: { type: 'text/javascript', src: this.src }});
                },
                props: {
                    src: { type: String, required: true },
                },
            },
        },
    }
</script>

<style scoped>

    .bottom_line {
        width: 100%;
        background-color: white;
        position: fixed;
        bottom: 0;
        border: 2px ridge #e68916;
    }
</style>


// WEBPACK FOOTER //
// src/views/AttachmentView.vue